import {ReplaySubject, combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';
import {spots2$} from '@/config';
import {spot$} from '@/state/spot';
import {displayAllMarginPairsOrder$} from '@/state/margin-all-symbols';
import {convertHistoryOrderData} from '@/spot-utils/order-data';
import {marginHistoryOrdersCache$} from './orders-history-cache';
import type {MarginPair, OrderData, ws} from '@/types';
import type {HistoryOrder} from '@/spot-utils/order-data';
import {convertSpotMarginOrder} from '../utils';

type MarginOrderRaw = ws.MarginOrderRaw;

const orderRaws$ = marginHistoryOrdersCache$.pipe(
  map((cache: Map<string, MarginOrderRaw>): MarginOrderRaw[] => cache.toArray())
);

export const spotHistoryOrderData$ = new ReplaySubject<OrderData<HistoryOrder>>(1);
export const marginHistoryOrderData$ = new ReplaySubject<OrderData<HistoryOrder>>(1);

combineLatest([orderRaws$, spots2$, spot$, displayAllMarginPairsOrder$])
  .pipe(
    map(([orderRaws, spotPairs, spot, displayAllMarginPairsOrder]) => {
      const {spotOrders, marginOrders} = convertSpotMarginOrder<MarginOrderRaw>(orderRaws);
      return {
        spotOrders: convertHistoryOrderData<MarginOrderRaw>(
          spotOrders,
          spotPairs,
          spot as MarginPair,
          displayAllMarginPairsOrder
        ),
        marginOrders: convertHistoryOrderData<MarginOrderRaw>(
          marginOrders,
          spotPairs,
          spot as MarginPair,
          displayAllMarginPairsOrder
        ),
      };
    })
  )
  .subscribe(({spotOrders, marginOrders}) => {
    spotHistoryOrderData$.next(spotOrders);
    marginHistoryOrderData$.next(marginOrders);
  });
